import { CoreApplicationContext } from '@eventbrite/context-gen';
import { getExperiment, initializeSdk, logEvent } from '@eventbrite/statsig';
import { AppProps, StatsigInitializationOptions } from '../types';
import { PAGE_VIEW } from './constants';

export const SAMPLE_RATE = 100;

export const getUserTrackingIDs = (
    request: CoreApplicationContext['request'],
) => ({
    correlationId: request.correlation_id,
});

export const initializeStatsigSdk = async (
    options: StatsigInitializationOptions,
) => {
    await initializeSdk({
        ...options,
        sampleRate: SAMPLE_RATE,
        deactivateSdk: false,
    });
};

export const getMetadata = (app: AppProps) => ({
    userID: `${app.user?.id}`,
    userPublicID: `${app.user?.publicId}`,
    userActiveOrganizationId: `${app.user?.activeOrganization?.id}`,
    isAttendee: `${app.user?.isAttendee}`,
    orgHasEvents: `${app.user?.orgHasEvents}`,
    domain: `${app.env.ebDomain}`,
    isMobile: `${app.env.isMobile}`,
    correlationId: `${app.request.correlation_id}`,
    sessionId: `${app.request.session_id}`,
    path: `${app.request.path}`,
});

export const logMlpPageView = (pathname: string) => {
    logEvent(PAGE_VIEW, pathname);
};

export const getExperimentFlag = (
    experimentName: string,
    paramName: string,
    defaultValue: boolean,
): boolean => {
    let result = defaultValue;
    const experimentResult = getExperiment<boolean, boolean>(
        experimentName,
        paramName,
        defaultValue,
    );

    // These conversion are required since getExperiment might return string.
    if (typeof experimentResult === 'string') {
        result = JSON.parse(experimentResult);
    }
    if (typeof experimentResult === 'boolean') {
        result = experimentResult;
    }

    return result;
};

export const getShowAttendeeCreatorToggleExperiment = (): boolean => {
    return getExperimentFlag(
        'show_nav_intent_toggle_ab',
        'showAttendeeCreatorToggle',
        false,
    );
};
